import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const runningLocal = process.env.REACT_APP_API_DOMAIN !== "sc";
const SitesService = runningLocal ?
                        require("../data/SitesService.dev").default :
                        require("../data/SitesService.prod").default;

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  label: {
    //fontSize: '16px'
  },
  formControl: {
    minWidth: 120
  },
  menuItem: {
    //fontSize: '16px'
  },
  select: {
    //fontSize: '16px'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  }
});

class SiteFilter extends React.Component {
  state = {
    site: "all",
    sites: null
  };

  componentDidMount() {
    console.log("SiteFilter: componentDidMount");
    SitesService.getSites()
      .then(sites =>
        this.setState({
          sites: sites
        })
      )
      .catch(err => console.error(err));
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
    console.log("site filter changed: " + event.target.value);
    this.props.onFilterChanged(event.target.value);
  };

  render() {
    const { classes } = this.props;
    const { sites } = this.state;
    if (!sites) {
      return null;
    }

    return (
      <form className={classes.root} autoComplete="off">
        <FormControl className={classes.formControl}>
          <InputLabel className={classes.label} htmlFor="site-filter">
            Site filter
          </InputLabel>
          <Select
            className={classes.select}
            value={this.state.site}
            onChange={this.handleChange}
            inputProps={{
              name: "site",
              id: "site-filter"
            }}
          >
            {sites.map(site => (
              <MenuItem key={site.key} className={classes.menuItem} value={site.key}>
                {site.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </form>
    );
  }
}

SiteFilter.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SiteFilter);



// WEBPACK FOOTER //
// ./src/components/SiteFilter.js